import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export const Loading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        sx={{
          color: "#fcca50",
        }}
      />
    </Box>
  );
};
